import $api from "../http";

/**
 * `Ф0` / `Ф3` (кабинет): действия со своей учётной записью.
 *
 * Все три шага удаления — только после входа и только своей записи: сервер
 * берёт субъекта из сессии, тело не нужно. Код подтверждения приходит письмом
 * и передаётся на второй шаг.
 */
export default class AccountService {
  /** Шаг 1: запрос удаления — письмо с кодом. */
  static async requestDeletion(): Promise<{
    codeSent: boolean;
    expiresAt: string | null;
  }> {
    const response = await $api.post("/account/deletion", {}, {
      withCredentials: true,
    });

    return response.data;
  }

  /** Шаг 2: подтверждение кодом — назначается срок удаления. */
  static async confirmDeletion(code: string): Promise<{
    state: string;
    dueAt: string | null;
    days: number;
    from: string | null;
  }> {
    const response = await $api.post(
      "/account/deletion/confirm",
      { code },
      { withCredentials: true },
    );

    return response.data;
  }

  /** Отмена после входа: учётка возвращается в прежнее состояние. */
  static async cancelDeletion(): Promise<{ state: string; cancelled: boolean }> {
    const response = await $api.post("/account/deletion/cancel", {}, {
      withCredentials: true,
    });

    return response.data;
  }
}
